import React from "react";
import {CircularProgress} from "@mui/material";
import styled from "@emotion/styled";

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 12px 0;

	.MuiCircularProgress-svg {
		color: ${({theme}) => theme.colorPalette.primary};
	}

	&.fixed {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background: ${({theme}) => theme.colorPalette.black};
		z-index: 9999;
	}
`;

interface IProps {
	fixed?: boolean;
}
export const Preloader: React.FC<IProps> = ({fixed}) => {
	const className = fixed ? "fixed" : "";
	return (
		<Wrapper className={className}>
			<CircularProgress />
		</Wrapper>
	);
};
